// The rows of the screen: the work orders a coverage report can be created for.
export const REPORTS_ENDPOINT = 'winter-service/reports'

// The report itself. It answers with the PDF, not with a link to one, so it is asked
// for as a blob and handed to the browser as a download.
export const buildWorkOrderReportEndpoint = (execRouteId) => `winter-coverage/${execRouteId}/report`

export const REPORTS_TABLE_KEY = 'winter-service-v2-reports'
export const REPORTS_UI_VIEW = 'winter_service2_reports'

export const REPORTS_INDEX_ROUTE = 'WinterService2Report'

export const REPORTS_TRANSLATION_NAMESPACE = 'road-maintenance/winter_service2/reports'

// The reports overview of the base module offers three ways to create a report and
// paints the icon by whether the row supports each. The winter service has one report
// and one way to get it, so the only pair kept is the enabled/disabled one.
export const CREATE_NOW_ICON = '/img/icons/report-play-icon.svg'
export const CREATE_NOW_DISABLED_ICON = '/img/icons/report-play-disabled-icon.svg'
